import { BreifInfluencerV2StatusEnum } from "@entities/brief/lib/constants";
import { useUpdatePaymentTerms } from "@entities/brief/lib/hooks/useAddPaymentTerms";
import { useGetBriefInfluencerSearchFacets } from "@entities/brief/lib/hooks/useGetBriefInfluencerSearchFacets";
import { IBriefInfluencerV2 } from "@shared/lib/types/briefInfluencerV2";
import { Button, Popover } from "@shared/ui";
import SelectInput from "@shared/ui/SelectInput";
import { Flex } from "antd";
import { useEffect, useState } from "react";
import styles from "./styles.module.scss";

interface BrandPaymentTermsProps {
  briefInfluencer: IBriefInfluencerV2;
  updateBriefInfluencer: (id: string, data: IBriefInfluencerV2) => void;
  briefId: string;
}

export default function BrandPaymentTerms({
  briefInfluencer,
  updateBriefInfluencer,
  briefId,
}: BrandPaymentTermsProps) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [editPaymentTerms, setEditPaymentTerms] = useState<{
    open: boolean;
    paymentTerms: string;
  }>({
    open: false,
    paymentTerms: briefInfluencer?.paymentTerms || "",
  });

  const { searchFacets } = useGetBriefInfluencerSearchFacets(
    briefId,
    BreifInfluencerV2StatusEnum.Shortlisted
  );

  const { updatePaymentTerms, isUpdating } = useUpdatePaymentTerms(
    briefId,
    () => {
      updateBriefInfluencer(briefInfluencer._id, {
        ...briefInfluencer,
        paymentTerms: editPaymentTerms.paymentTerms,
      });
      setEditPaymentTerms((prev) => ({ ...prev, open: false }));
    }
  );

  useEffect(() => {
    if (!editPaymentTerms.open) {
      setEditPaymentTerms((prev) => ({
        ...prev,
        paymentTerms: briefInfluencer?.paymentTerms || "",
      }));
    }
  }, [briefInfluencer?.paymentTerms, editPaymentTerms.open]);

  return (
    <Popover
      trigger={["click"]}
      open={editPaymentTerms.open}
      // title="Select Payment Term"
      placement="right"
      destroyTooltipOnHide
      onOpenChange={(open) => {
        if (!open) {
          setDropdownOpen(false);
        }
        setEditPaymentTerms({
          open,
          paymentTerms: briefInfluencer?.paymentTerms || "",
        });
      }}
      content={
        <Flex
          vertical
          gap={10}
          style={{ width: "220px" }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <SelectInput
            key={String(editPaymentTerms.open)}
            // placeholder={""}
            placeholder="Select payment terms"
            allowClear
            showSearch
            onSearch={() => {}}
            value={editPaymentTerms.paymentTerms || ""}
            isFetching={false}
            dropdownOpen={dropdownOpen}
            setDropdownOpen={setDropdownOpen}
            options={
              searchFacets?.paymentTerms?.map((p) => ({
                label: p._id,
                value: p._id,
              })) || []
            }
            onchange={(value) =>
              setEditPaymentTerms((prev) => ({
                ...prev,
                paymentTerms: (value as string) || "",
              }))
            }
            newItem={{
              placeholder: "Enter a new payment term",
              addNewItem: (item) =>
                setEditPaymentTerms((prev) => ({
                  ...prev,
                  paymentTerms: item,
                })),
              addButtonText: "Add payment term",
            }}
          />
          <Button
            type="primary"
            loading={isUpdating}
            onClick={() => {
              updatePaymentTerms({
                briefInfluencerId: briefInfluencer._id,
                paymentTerms: editPaymentTerms.paymentTerms,
              });
            }}
            size="small"
            style={{ width: "100%" }}
          >
            Save
          </Button>
        </Flex>
      }
    >
      <span
        className={styles.paymentTermsTrigger}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {briefInfluencer?.paymentTerms || "-"}
      </span>
    </Popover>
  );
}
